export enum SearchFilterName {
  library = 'library',
  source = 'source',
  eosl = 'eosl',
  productId = 'productId',
  familyId = 'familyId',
  version = 'version',
  publicationType = 'publicationType',
  priority = 'priority',
  status = 'status',
  project = 'project',
  mediaType = 'mediaType',
  entityType = 'entityType',
  group = 'group',
  productVersionPaths = 'productVersionPaths',
  tags = 'tags'
}
